/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

  window.addEventListener("load", function() { 
    
  var elements = document.getElementsByClassName("ProductCollection__AddToCart");

  for (var i = 0; i < elements.length; i++) {
     elements[i].addEventListener('click', function(){ 
   	 addItemToCart(this.getAttribute("data-varId"));    // paste your id product number
  	 });
  }

  function addItemToCart(variant_id) {
    data = {
      "id": variant_id,
      "quantity": 1
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {             
      document.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
         detail: { }
      }));          
      }
    });
  }
  })
   
  
  document.addEventListener('theme:loading:end', updatesearchheight); 
    function updatesearchheight(){
      if(window.innerWidth>=1240)
      {
        setTimeout(function() {
          var heights = $("div.ss.Grid__Cell").map(function ()                                                  
          {
            return $(this).height();
          }).get();
          maxHeight = Math.max.apply(null, heights);
          var vNavimg = $("div.ss.Grid__Cell");
          for(var i=0;i<vNavimg.length;i++){
            vNavimg[i].style.height = maxHeight+"px";
          }        
        }, 200);    
      }
  }    



  
    // Create a function to add the event listener to the checkout button
    function addCheckoutButtonEventListener() {
      let parentElement = document.getElementById('sidebar-cart');
    
      if (parentElement) {
        parentElement.addEventListener('change', function(event) {
        let checkoutButton = document.querySelector('#sidebar-cart [name="checkout"]');
        if(checkoutButton){checkoutButton.disabled = true;} // Disable the button initially
          
          if (event.target.matches('#agree')) {
            checkoutButton.disabled = !event.target.checked; // Enable/disable the button based on the checkbox state
          }
        });
      }
    }
    
    // Call the addCheckoutButtonEventListener function only once
    addCheckoutButtonEventListener();
  